"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressTrackerStep = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var __1 = require("../");
var ProgressTrackerStep = function (_a) {
    var _b = _a.active, active = _b === void 0 ? false : _b, className = _a.className, _c = _a.completed, completed = _c === void 0 ? false : _c, disabled = _a.disabled, editing = _a.editing, label = _a.label, stepNumber = _a.stepNumber, props = __rest(_a, ["active", "className", "completed", "disabled", "editing", "label", "stepNumber"]);
    var getBadge = function () {
        if (completed)
            return react_1.default.createElement(__1.Icon, { name: "check" });
        if (editing)
            return react_1.default.createElement(__1.Icon, { name: "edit" });
        return stepNumber;
    };
    var ProgressTrackerStepClasses = classnames_1.default('ProgressTrackerStep', className, {
        'ProgressTrackerStep--active': active,
        'ProgressTrackerStep--complete': completed,
        'ProgressTrackerStep--clickable': !disabled && (props.href != null || props.onClick != null),
        'ProgressTrackerStep--disabled': disabled,
        'ProgressTrackerStep--editing': editing,
    });
    var StepElement = props.href ? 'a' : 'div';
    return (react_1.default.createElement(StepElement, __assign({ className: ProgressTrackerStepClasses, tabIndex: (props.href || props.onClick) && 0 }, props),
        react_1.default.createElement("div", { className: "ProgressTrackerStep__icon" }, getBadge()),
        label && react_1.default.createElement("div", { className: "ProgressTrackerStep__label" }, label)));
};
exports.ProgressTrackerStep = ProgressTrackerStep;
//# sourceMappingURL=ProgressTrackerStep.js.map